<template>
    <v-card :elevation="5" @click="openDetails(game)">
        <v-img v-if="conditions.screen" :src="hero" class="white--text align-end" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)" height="200px">
            <v-card-title v-text="game.title" class="game-title"></v-card-title>
            <div style="position: absolute; top:0; left:0;">
                <v-chip v-if="game.isGamePass" class="ma-2" color="primary" small style="box-shadow: 0 0 1em rgb(255 255 255); margin-right: 0px !important;">
                    <v-avatar left style="margin-right: 0px;">
                        <v-icon small>mdi-microsoft-xbox</v-icon>
                    </v-avatar>
                    GAMEPASS
                </v-chip>
                <v-chip v-if="game.isEaPlay" class="ma-2" color="red" small style="box-shadow: 0 0 1em rgb(255 255 255);">
                    <v-avatar left style="margin-right: 0px;">
                        <v-icon small>mdi-microsoft-xbox-controller</v-icon>
                    </v-avatar>
                    EAPlay
                </v-chip>
            </div>
        </v-img>
        <v-card-title v-if="!conditions.screen" class="one-line">{{ game.title }}</v-card-title>
        <v-card-subtitle dense>{{ platform }}</v-card-subtitle>
        <v-card-text dense>{{ genres }}</v-card-text>

        <v-divider></v-divider>

        <v-list-item dense>
            <v-list-item-icon style="margin-right: 0px !important;">
                <v-icon small v-if="conditions.locale === 'ko-kr'">mdi-currency-krw</v-icon>
                <v-icon small v-else>mdi-currency-usd</v-icon>
            </v-list-item-icon>
            <v-list-item-subtitle>{{ curPrice }} <span v-if="game.isOnSale">(<strike>{{ formated(game.oriPrice) }}</strike> / {{ percent }}%)</span></v-list-item-subtitle>
            <v-spacer/>
            <v-list-item-action-text align="right" style="width: 300px;">{{ game.dayLeft }}</v-list-item-action-text>
        </v-list-item>

        <v-list-item v-if="conditions.period && !game.isDiscountPresent" dense>
            <v-list-item-icon style="margin-right: 0px !important;">
                <v-icon small>mdi-calendar-month</v-icon>
            </v-list-item-icon>
            <v-list-item-subtitle>Release Date</v-list-item-subtitle>
            <v-spacer/>
            <v-list-item-action-text align="right" style="width: 300px;">{{ game.releaseDate }}</v-list-item-action-text>
        </v-list-item>
        <div v-if="conditions.history && game.discounts.length > 0">
            <v-divider></v-divider>
            <game-sparkline :price="game.oriPrice" :discounts="game.discounts" />
        </div>
    </v-card>
</template>

<script>
import GameSparkline from './GameSparkline'
import noImage from '../assets/no-image.png'
import numeral from 'numeral'
import _ from 'lodash'

export default {
    props: [ 'game', 'conditions', 'locale' ],
    data: () => ({

    }),
    computed: {
        hero () {
            return (this.game.cover) ? `https://store-images.s-microsoft.com/image/${this.game.cover}` : noImage
            // let screens = this.game.screens
            // return (!!screens && screens.length > 0) ? screens[0] : noImage
        },
        genres () {
            return this.game.genres.map(genre => _.words(genre).map(inGenre => _.capitalize(inGenre)).join(' ')).join(', ')
        },
        platform () {
            let platformArr = []
            if (this.game.isPlatformXsx) platformArr.push('Xbox Series X|S')
            if (this.game.isPlatformXo) platformArr.push('Xbox One')
            if (this.game.isPlatformPc) platformArr.push('PC')
            return platformArr.join(', ')
        },
        curPrice () {
            return (this.game.isOnSale) ? this.formated(this.game.curPrice) : this.formated(this.game.oriPrice)
        },
        percent () {
            return numeral((1 - (this.game.curPrice / this.game.oriPrice)) * 100).format('0')
        }
    },
    methods: {
        openDetails (game) {
            console.log(game)
            this.$emit('open-details', game)
        },
        formated (price) {
            return (this.locale == 'ko-kr') ? numeral(price).format('#,##0') : numeral(price).format('0.00')
        }
    },
    components: {
        'game-sparkline': GameSparkline
    }
}
</script>

<style scoped>
.game-title {
    text-shadow: 0 0 2px #000, 0 0 10px #fff;
}
.one-line {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
</style>